import { render, staticRenderFns } from "./SignupFormV2.vue?vue&type=template&id=76ad3b9f&scoped=true&"
import script from "./SignupFormV2.vue?vue&type=script&lang=ts&"
export * from "./SignupFormV2.vue?vue&type=script&lang=ts&"
import style0 from "./SignupFormV2.vue?vue&type=style&index=0&id=76ad3b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ad3b9f",
  null
  
)

export default component.exports